import type { PartnerMembershipProgramCreateApiData, PartnerMembershipProgramPatchApiData } from '@navio/nsdk';
import type { ApiInput } from '../../utils';

const appendIds = (formData: FormData, key: string, ids: number[] | undefined) => {
  if (ids === undefined) {
    return;
  }
  for (const id of ids) {
    formData.append(key, String(id));
  }
};

const appendImage = (formData: FormData, image: File | Blob | null | undefined) => {
  if (image instanceof Blob) {
    formData.append('image', image);
    return;
  }
  if (image === null) {
    formData.append('image', '');
  }
};

export const partnerProgramCreateFormData = ({
  brandId: _brandId,
  serviceOrganizationId,
  name,
  slug,
  description,
  authCode,
  membershipDiscountIds,
  image
}: ApiInput<PartnerMembershipProgramCreateApiData>): FormData => {
  const formData = new FormData();
  formData.append('service_organization_id', String(serviceOrganizationId));
  formData.append('name', name);
  formData.append('slug', slug);
  formData.append('description', description);
  formData.append('auth_code', authCode);
  appendIds(formData, 'membership_discount_ids', membershipDiscountIds);
  appendImage(formData, image);
  return formData;
};

export const partnerProgramPatchFormData = ({
  membershipProgramId: _,
  name,
  slug,
  description,
  authCode,
  membershipDiscountIds,
  image
}: ApiInput<PartnerMembershipProgramPatchApiData>): FormData => {
  const formData = new FormData();
  if (name != null) {
    formData.append('name', name);
  }
  if (slug != null) {
    formData.append('slug', slug);
  }
  if (description != null) {
    formData.append('description', description);
  }
  if (authCode != null) {
    formData.append('auth_code', authCode);
  }
  appendIds(formData, 'membership_discount_ids', membershipDiscountIds ?? undefined);
  appendImage(formData, image);
  return formData;
};
